import { css } from 'styled-components';

import { BodySmallSemiBold, BodyXSmallSemiBold } from '@xemplo/style-constants';

import { InputSize } from '../xemplo-input.types';

/**
 * Base styling for the label element.
 * IMPORTANT: Definitions for the floating label
 * is defined within the `inputFloatingLabelStyles`
 * in `xemplo-input.input.ts`.
 *
 * The `.left` offset clears the leading icon and must line the label up with
 * the input text: padding 16px + icon 24px + gap 8px = 48px. Default and
 * Spacious both use 24px icons, so both use 48px.
 */
export const labelStyles = css`
  color: var(--input-label-text-color);
  position: absolute;
  left: 16px;
  transition: all 0.1s ease-out;

  &.${InputSize.Spacious} {
    ${BodySmallSemiBold};
    top: 20.5px;

    &.left {
      left: 48px;
    }
  }

  &.${InputSize.Default} {
    ${BodyXSmallSemiBold};
    top: 14.25px;

    &.left {
      left: 48px;
    }
  }
`;

/**
 * An accessible visually hidden label styling definition
 * @deprecated due to clash when used in systems like Hire or GP
 * that uses a mix of other css frameworks. Use `visuallyHiddenV2`
 * instead and update the markup to use `visually-hidden` class.
 */
export const visuallyHidden = css`
  &.hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    border: 0;
  }
`;

/**
 * A new visually hidden styling definition that uses a more specific
 * class name to avoid clashes with other CSS frameworks.
 */
export const visuallyHiddenV2 = css`
  &.visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    border: 0;
  }
`;

export const inputLabelBaseStyles = css`
  ${labelStyles};
  ${visuallyHidden};
`;
